import { styled } from '@mui/material/styles'

export const CustomFieldText = styled('div', {
  name: 'CustomFieldText',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  marginRight: 'auto',
  marginLeft: theme.spacing(2),
}))
